import { ReactChild, useEffect, useRef } from "react";

import FocusTrap from "focus-trap-react";

import { Expand } from "../../../components";

import { Button, Nav, Shroud } from "./SubNav.styles";

type SubNavProps = {
    title: ReactChild;
    children: ReactChild;
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    buttonTestId?: string;
};

const SubNav = ({
    title,
    children,
    isOpen,
    setIsOpen,
    buttonTestId
}: SubNavProps) => {
    const subNav = useRef<HTMLDivElement | null>(null);

    //prevent body scrolling when nav is open, close when escape pressed
    useEffect(() => {
        const escPress = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            window.addEventListener("keydown", escPress);
            document.body.classList.add("prevent-scroll");
        }
        return () => {
            window.removeEventListener("keydown", escPress);
            document.body.classList.remove("prevent-scroll");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [isOpen]);

    return (
        <FocusTrap
            active={isOpen}
            focusTrapOptions={{
                allowOutsideClick: true,
                fallbackFocus: "#skip-to-content"
            }}
        >
            <Shroud data-open={isOpen} onClick={() => setIsOpen(false)}>
                <Nav
                    data-open={isOpen}
                    onClick={(e) => e.stopPropagation()}
                    ref={subNav}
                >
                    <Button
                        data-open={isOpen}
                        data-testid={buttonTestId}
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {title}
                    </Button>
                    <Expand show={isOpen}>{children}</Expand>
                </Nav>
            </Shroud>
        </FocusTrap>
    );
};

export default SubNav;
